import React, { useState } from "react";
import serene1 from "../assets/product2.jpg";
import serene2 from "../assets/Serene2.jpg";
import serene3 from "../assets/SereneSand.jpg";
import serene4 from "../assets/SereneBox.png";
import ImageSerene from "../components/landing/ImageSerene";

const SereneBliss = () => {
  const [openDropdown, setOpenDropdown] = useState(null);
  const [popupIndex, setPopupIndex] = useState(null);
  const images = [serene1, serene2, serene3, serene4];

  const toggleDropdown = (name) =>
    setOpenDropdown(openDropdown === name ? null : name);

  const shopeeLink =
    "https://shopee.co.id/Perfume-by-SORIN-Serene-Bliss-EDP-50ml-i.1412228583.43069004318?extraParams=%7B%22display_model_id%22%3A281558593599%7D";

  const handleBuyNow = () => {
    window.open(shopeeLink, "_blank");
  };

  const openPopup = (index) => setPopupIndex(index);
  const closePopup = () => setPopupIndex(null);
  const nextImage = () =>
    setPopupIndex((prev) => (prev + 1) % images.length);
  const prevImage = () =>
    setPopupIndex((prev) => (prev - 1 + images.length) % images.length);

  return (
    <>
      {/* ✅ Global reset untuk full width */}
      <style>
        {`
          * {
            margin: 0;
            padding: 0;
            box-sizing: border-box;
          }

          /* ✅ Image grid responsive - cover untuk mengisi penuh */
          .image-grid-item-serene {
            width: 100%;
            aspect-ratio: 1 / 1;
            border-radius: 6px;
            overflow: hidden;
            box-shadow: 0 3px 10px rgba(0,0,0,0.1);
            cursor: pointer;
            background-color: #f0f0f0;
          }

          .image-grid-item-serene img {
            width: 100%;
            height: 100%;
            object-fit: cover !important;
            object-position: center;
            transition: transform 0.3s ease;
          }

          .image-grid-item-serene:hover img {
            transform: scale(1.08);
          }

          @media (max-width: 768px) {
            #serene-section {
              padding: 100px 30px 40px 30px !important;
              flex-direction: column;
            }
            .image-grid-serene {
              grid-template-columns: 1fr 1fr !important;
              min-width: unset !important;
              gap: 12px !important;
            }
            .left-content-serene {
              max-width: 100% !important;
              min-width: unset !important;
            }
          }

          @media (max-width: 480px) {
            .image-grid-serene {
              grid-template-columns: 1fr !important;
              max-width: 400px;
              margin: 0 auto;
            }
            #serene-section {
              padding: 100px 20px 40px 20px !important;
            }
          }
        `}
      </style>

      <section
        id="serene-section"
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
          flexWrap: "wrap",
          padding: "100px 80px 60px 80px",
          backgroundColor: "#f7f7f5",
          minHeight: "100vh",
          boxSizing: "border-box",
          gap: "40px",
        }}
      >
        {/* === LEFT SIDE === */}
        <div 
          className="left-content-serene"
          style={{ 
            flex: "1", 
            minWidth: "400px", 
            maxWidth: "540px" 
          }}
        >
          <h1
            style={{
              fontFamily: "DM Serif Display, serif",
              fontSize: "2.6rem",
              marginBottom: "10px",
              color: "#111",
            }}
          >
            Serene Bliss
          </h1>

          <p
            style={{
              color: "#777",
              marginBottom: "15px",
              letterSpacing: "1px",
            }}
          >
            EXTRAIT DE PARFUM — 50 ml
          </p>

          {/* ✅ PRICE WITH STRIKETHROUGH */}
          <div
            style={{
              display: "flex",
              alignItems: "baseline",
              gap: "12px",
              marginBottom: "25px",
            }}
          >
            <p
              style={{
                fontSize: "1.5rem",
                fontWeight: "600",
                color: "#000",
                margin: 0,
                lineHeight: 1,
              }}
            >
              Rp195.000
            </p>
            <p
              style={{
                fontSize: "1.1rem",
                fontWeight: "400",
                color: "#999",
                textDecoration: "line-through",
                margin: 0,
                lineHeight: 1,
              }}
            >
              Rp299.000
            </p>
          </div>

          <p
            style={{
              fontSize: "1rem",
              color: "#444",
              lineHeight: "1.7",
              marginBottom: "35px",
              maxWidth: "95%",
            }}
          >
            Serene Bliss embodies the perfect harmony between floral elegance and
            woody depth, creating a magnetic impression that feels effortlessly
            refined. Designed for everyday wear, it offers sophistication and
            confidence at once.
          </p>

          {/* === DROPDOWNS === */}
          <div style={{ marginBottom: "40px" }}>
            {/* --- Ingredients --- */}
            <div
              style={{
                borderBottom: "1px solid #ddd",
                padding: "14px 0",
                cursor: "pointer",
              }}
              onClick={() => toggleDropdown("Ingredients")}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <p
                  style={{
                    fontWeight: "500",
                    fontSize: "1rem",
                    color: "#111",
                    letterSpacing: "0.5px",
                  }}
                >
                  Ingredients
                </p>
                <span style={{ fontSize: "1.2rem" }}>
                  {openDropdown === "Ingredients" ? "−" : "+"}
                </span>
              </div>

              {openDropdown === "Ingredients" && (
                <div
                  style={{
                    marginTop: "12px",
                    fontSize: "0.95rem",
                    color: "#333",
                    lineHeight: "1.7",
                  }}
                >
                  <p>
                    <strong>Top:</strong> Rose, Lychee, Woody Accord, Geranium,
                    Oud, Fresh Spices, Iris Butter, Angelica
                  </p>
                  <p>
                    <strong>Middle:</strong> Jasmine, Freesia, Patchouli,
                    Leathery Accord, Lily of the Valley, Cashmere Wood, Ambrette
                  </p>
                  <p>
                    <strong>Base:</strong> Musk, Gourmand Accord, Red Fruits,
                    White Sandalwood, Patchouli, Spices, Cedarwood, Ambergris
                  </p>
                </div>
              )}
            </div>

            {/* --- Performance --- */}
            <div
              style={{
                borderBottom: "1px solid #ddd",
                padding: "14px 0",
                cursor: "pointer",
              }}
              onClick={() => toggleDropdown("Performance")}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                <p
                  style={{
                    fontWeight: "500",
                    fontSize: "1rem",
                    color: "#111",
                    letterSpacing: "0.5px",
                  }}
                >
                  Performance
                </p>
                <span style={{ fontSize: "1.2rem" }}>
                  {openDropdown === "Performance" ? "−" : "+"}
                </span>
              </div>

              {openDropdown === "Performance" && (
                <div
                  style={{
                    marginTop: "12px",
                    fontSize: "0.95rem",
                    color: "#333",
                    lineHeight: "1.8",
                  }}
                >
                  <p
                    style={{
                      marginBottom: "12px",
                      marginLeft: "0",
                    }}
                  >
                    Serene Bliss is crafted for those who live gracefully and radiate quiet confidence, a scent that glows softly and stays with you through every moment of the day.
                  </p>
                  <ul
                    style={{
                      paddingLeft: "20px",
                      marginTop: "0",
                    }}
                  >
                    <li>
                      <strong>Sillage:</strong> Moderate to Strong
                    </li>
                    <li>
                      <strong>Projection:</strong> Moderate
                    </li>
                    <li>
                      <strong>Longevity:</strong> 8–10 hours
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </div>

          {/* === BUTTON (Shopee Link) === */}
          <button
            onClick={handleBuyNow}
            style={{
              width: "100%",
              padding: "14px 0",
              backgroundColor: "#000",
              color: "#fff",
              fontWeight: "600",
              border: "none",
              borderRadius: "6px",
              cursor: "pointer",
              transition: "all 0.3s ease",
              boxShadow: "0 4px 8px rgba(0,0,0,0.15)",
            }}
            onMouseOver={(e) =>
              (e.currentTarget.style.backgroundColor = "#dc814c")
            }
            onMouseOut={(e) => (e.currentTarget.style.backgroundColor = "#000")}
          >
            SHOP NOW
          </button>
        </div>

        {/* === RIGHT SIDE (GRID 2×2 IMAGES) === */}
        <div
          className="image-grid-serene"
          style={{
            flex: "1",
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "14px",
            minWidth: "480px",
          }}
        >
          {images.map((img, i) => (
            <div
              key={i}
              className="image-grid-item-serene"
              onClick={() => openPopup(i)}
            >
              <img
                src={img}
                alt={`Serene Bliss view ${i + 1}`}
              />
            </div>
          ))}
        </div>

        {/* === POPUP COMPONENT === */}
        {popupIndex !== null && (
          <ImageSerene
            images={images}
            currentIndex={popupIndex}
            onClose={closePopup}
            onNext={nextImage}
            onPrev={prevImage}
          />
        )}
      </section>
    </>
  );
};

export default SereneBliss;